import React from "react"
import { withPrefix } from "gatsby"
import HomepageLogoLink from "../components/homepage-logo-link"
import SiteFooterTwitter from "../components/site-footer-twitter"
import SiteFooterInstagram from "../components/site-footer-instagram"
import CTA from "../components/cta"
import DownloadFullReport from "../components/download-full-report"
import Safe from "react-safe"

export default function SiteFooter({ path }) {
  const description =
    "The International Monetary Fund (IMF) is a global organization of 190 member countries set up to promote the health of the world economy."
  const pathArray = path.split("/")

  const lastPathSegment =
    (pathArray !== "" ? pathArray.pop() || pathArray.pop() : pathArray) ||
    "home"

  return (
    <footer className="site-footer">
      <ul className="site-footer__main container">
        <li className="site-footer__about">
          <header>
            <HomepageLogoLink classes="site-footer__about__logo" path={path} />
          </header>
          <p>{description}</p>
          <CTA
            type="secondary"
            href="https://www.imf.org/"
            text="Visit IMF.org"
          />
        </li>
        <SiteFooterTwitter path={lastPathSegment} />
        <SiteFooterInstagram path={lastPathSegment} />
      </ul>
      <div className="site-footer__bottom">
        <div className="container site-footer__bottom__inner">
          <DownloadFullReport />
          <p className="title--micro title--light">
            Credits for images found in this website can be found{" "}
            <u>
              <a href={withPrefix("/") + "downloads/photo-credits.pdf"}>
                here.
              </a>
            </u>
          </p>
        </div>
      </div>

      <Safe.script type="text/javascript">_satellite.pageBottom();</Safe.script>
    </footer>
  )
}
